import { Box, Flex } from 'styled-system/jsx';
import RetakeIcon from '@/common/assets/icons/retakeIcon.svg?react';
import ConfirmationIcon from '@/common/assets/icons/tikIcon.svg?react';
import RotateIcon from '@/common/assets/icons/rotateAndEditIcon.svg?react';
import { ImageType } from '@/common/components/imageGallery/components/Extensions/moreItemsExtension/moreItemsExtension.type';
import { css } from 'styled-system/css';
const UploadDocumentImageConfirmation = ({
  image,
  confirmationHandler,
  editHandler,
  onClose,
  retakeHandler,
}: {
  image: ImageType | null;
  retakeHandler: () => void;
  editHandler: () => void;
  onClose: () => void;
  confirmationHandler: () => void;
}) => {
  return (
    <Box
      backgroundColor="black"
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      zIndex={'camera'}
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        className={css({ width: '100%', height: '100%' })}
      >
        <img className={css({ width: '100%' })} src={image?.url as any} />
      </Flex>
      <Flex
        backgroundColor="black"
        backdropOpacity="80"
        position="absolute"
        height="120px"
        right="0"
        bottom="0"
        left="0"
        justifyContent="space-around"
        alignItems="center"
      >
        <Box
          onClick={() => {
            retakeHandler();
            onClose();
          }}
        >
          <RetakeIcon />
        </Box>
        <Box
          onClick={() => {
            editHandler();
            onClose();
          }}
        >
          <RotateIcon />
        </Box>{' '}
        <Box
          onClick={() => {
            confirmationHandler();
            onClose();
          }}
        >
          <ConfirmationIcon />
        </Box>
      </Flex>
    </Box>
  );
};

export default UploadDocumentImageConfirmation;
